/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import OfficeVisitDataContent from "components/content/NewOfficeVisitDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * New office visit creation page.
 * Initiates a new patient office visit workflow.
 * 
 * Features:
 * - Patient selection and verification
 * - Visit type selection
 * - Chief complaint entry
 * - Provider assignment
 * - Check-in timestamp recording
 * - Visit workflow initialization
 * - Integration with vitals and progress notes
 * - Automatic appointment linking if applicable
 * 
 * Note: Component exported as NewAppointmentPage but handles
 * office visit creation, which is distinct from appointment scheduling.
 * 
 * @returns {JSX.Element} New office visit page component
 */
const NewAppointmentPage = () => {
  return (
    <DefaultDashboardLayout>
      <OfficeVisitDataContent />
    </DefaultDashboardLayout>
  );
};

export default NewAppointmentPage;

